export default "__VITE_ASSET__CW9lrhwo__"